// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/portal_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { PortalAccountServiceGetBrandByFirestoreIdRequest, PortalAccountServiceGetBrandByFirestoreIdResponse, PortalAccountServiceGetBrandByIdRequest, PortalAccountServiceGetBrandByIdResponse, PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest, PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse, PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest, PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse, PortalAccountServiceGetDMAccountsRequest, PortalAccountServiceGetDMAccountsResponse, PortalAccountServiceGetFanByEmailRequest, PortalAccountServiceGetFanByEmailResponse, PortalAccountServiceGetFanByFirestoreIdRequest, PortalAccountServiceGetFanByFirestoreIdResponse, PortalAccountServiceGetMeRequest, PortalAccountServiceGetMeResponse, PortalAccountServiceGetTenantByFirestoreIdRequest, PortalAccountServiceGetTenantByFirestoreIdResponse, PortalAccountServiceRegisterUserRequest, PortalAccountServiceRegisterUserResponse, PortalAccountServiceSaveUserMemoRequest, PortalAccountServiceSaveUserMemoResponse, PortalAccountServiceUpdateUserRequest, PortalAccountServiceUpdateUserResponse } from "./portal_service_pb";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";
/**
 * @generated from service spwn.account.v1.PortalAccountService
 */
export const PortalAccountService = {
    typeName: "spwn.account.v1.PortalAccountService",
    methods: {
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.RegisterUser
         */
        registerUser: {
            name: "RegisterUser",
            I: PortalAccountServiceRegisterUserRequest,
            O: PortalAccountServiceRegisterUserResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.UpdateUser
         */
        updateUser: {
            name: "UpdateUser",
            I: PortalAccountServiceUpdateUserRequest,
            O: PortalAccountServiceUpdateUserResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetMe
         */
        getMe: {
            name: "GetMe",
            I: PortalAccountServiceGetMeRequest,
            O: PortalAccountServiceGetMeResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetFanByFirestoreId
         */
        getFanByFirestoreId: {
            name: "GetFanByFirestoreId",
            I: PortalAccountServiceGetFanByFirestoreIdRequest,
            O: PortalAccountServiceGetFanByFirestoreIdResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetFanByEmail
         */
        getFanByEmail: {
            name: "GetFanByEmail",
            I: PortalAccountServiceGetFanByEmailRequest,
            O: PortalAccountServiceGetFanByEmailResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetBrandById
         */
        getBrandById: {
            name: "GetBrandById",
            I: PortalAccountServiceGetBrandByIdRequest,
            O: PortalAccountServiceGetBrandByIdResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetBrandByFirestoreId
         */
        getBrandByFirestoreId: {
            name: "GetBrandByFirestoreId",
            I: PortalAccountServiceGetBrandByFirestoreIdRequest,
            O: PortalAccountServiceGetBrandByFirestoreIdResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetTenantByFirestoreId
         */
        getTenantByFirestoreId: {
            name: "GetTenantByFirestoreId",
            I: PortalAccountServiceGetTenantByFirestoreIdRequest,
            O: PortalAccountServiceGetTenantByFirestoreIdResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetDMAccounts
         */
        getDMAccounts: {
            name: "GetDMAccounts",
            I: PortalAccountServiceGetDMAccountsRequest,
            O: PortalAccountServiceGetDMAccountsResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetCoreFanByBrandIdAndUserId
         */
        getCoreFanByBrandIdAndUserId: {
            name: "GetCoreFanByBrandIdAndUserId",
            I: PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest,
            O: PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.SaveUserMemo
         */
        saveUserMemo: {
            name: "SaveUserMemo",
            I: PortalAccountServiceSaveUserMemoRequest,
            O: PortalAccountServiceSaveUserMemoResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.Idempotent,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetCoreFanBrandFirestoreIdsByUserId
         */
        getCoreFanBrandFirestoreIdsByUserId: {
            name: "GetCoreFanBrandFirestoreIdsByUserId",
            I: PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest,
            O: PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.Idempotent,
        },
    }
};
//# sourceMappingURL=portal_service_connect.js.map